export const PERMISSION_DISPLAY_NAMES = {
    show_survey: "Show survey",
    sort_by_votes: "Sort by votes",
    can_view_votes: "Can view all votes",
    can_move_cards: "Can move cards",
    can_vote_cards: "Can vote cards",
    can_merge_cards: "Can merge cards",
    can_view_other_cards: "Can view all cards",
    can_create_actions: "Can create actions",
};

